import axios from "axios";
import * as API_LINKS from '../config/links.jsx'
import {toast} from 'react-toastify'

export const FETCH_TRANSPORTER_DELIVERY_CONFIRMATION_DETAILS = 'FETCH_TRANSPORTER_DELIVERY_CONFIRMATION_DETAILS'
export const RECEIVE_TRANSPORTER_DELIVERY_CONFIRMATION_DETAILS = 'RECEIVE_TRANSPORTER_DELIVERY_CONFIRMATION_DETAILS'
export const FAILED_TRANSPORTER_DELIVERY_CONFIRMATION_DETAILS = 'FAILED_TRANSPORTER_DELIVERY_CONFIRMATION_DETAILS'

export function fetchTransporterDeliveryConfirmation(_id){

    return (dispatch, getState) => {
        dispatch({type: FETCH_TRANSPORTER_DELIVERY_CONFIRMATION_DETAILS});
        axios({
            method: 'post',
            url: API_LINKS.TRANSPORTER_DELIVERY_CONFIRMATION_DETAILS_URL,
            data: {
                share_data: _id
            }
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_TRANSPORTER_DELIVERY_CONFIRMATION_DETAILS,
                payload: response.data
            })
            console.log(response.data)
        })
        .catch(function(error){
            if(error.response){
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_TRANSPORTER_DELIVERY_CONFIRMATION_DETAILS
                    })
                    return toast.error("Unathorized access!");
                    
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_TRANSPORTER_DELIVERY_CONFIRMATION_DETAILS
                    })
                    return toast.error("Failed in fetching the data! Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_TRANSPORTER_DELIVERY_CONFIRMATION_DETAILS
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_TRANSPORTER_DELIVERY_CONFIRMATION_DETAILS
                    })
                    return toast.error("Please contact your system adminitrator")
                }
            }else if (error.request) {
                dispatch({
                    type: FAILED_TRANSPORTER_DELIVERY_CONFIRMATION_DETAILS
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_TRANSPORTER_DELIVERY_CONFIRMATION_DETAILS
                })
                return toast.error('Something went wrong... Please try again later...')
            }

        })
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/aTransporter-DeliveryConfirmationDetails.jsx